import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Preloader } from "@/components/Preloader";
import LandingPage from "@/pages/LandingPage";
import ReviewSubmitPage from "@/pages/ReviewSubmitPage";
import CareersPage from "@/pages/CareersPage";
import TripTypePage from "@/pages/TripTypePage";
import LegalPage from "@/pages/LegalPage";
import AdminPage from "@/pages/AdminPage";
import SetPasswordPage from "@/pages/SetPasswordPage";
import TourPayPage from "@/pages/TourPayPage";
import PackagesPage from "@/pages/PackagesPage";
import PackageDetailPage from "@/pages/PackageDetailPage";
import ComparePage from "@/pages/ComparePage";
import PlanMyTripPage from "@/pages/PlanMyTripPage";
import PicnicFeedbackPage from "@/pages/PicnicFeedbackPage";
import FlightSearchPage from "@/pages/FlightSearchPage";
import FlightResultsPage from "@/pages/FlightResultsPage";
import FlightCheckoutPage from "@/pages/FlightCheckoutPage";
import MyTripsPage from "@/pages/MyTripsPage";
import PartnersPage from "@/pages/PartnersPage";
import PartnerRegisterPage from "@/pages/PartnerRegisterPage";
import PartnerAuthPage from "@/pages/PartnerAuthPage";
import PartnerDashboardPage from "@/pages/PartnerDashboardPage";
import { captureReferral } from "@/lib/referral";

function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const el = document.getElementById(hash.slice(1));
            if (el) {
                el.scrollIntoView({ behavior: "smooth" });
                return;
            }
        }
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname, hash]);
    return null;
}

function ReferralCapture() {
    const { search } = useLocation();
    useEffect(() => { captureReferral(); }, [search]);
    return null;
}

function App() {
    return (
        <div className="App">
            <Preloader />
            <BrowserRouter>
                <ScrollToTop />
                <ReferralCapture />
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/review" element={<ReviewSubmitPage />} />
                    <Route path="/careers" element={<CareersPage />} />
                    <Route path="/privacy-policy" element={<LegalPage kind="privacy-policy" />} />
                    <Route path="/terms" element={<LegalPage kind="terms" />} />
                    <Route path="/school-trips" element={<TripTypePage slug="school-trips" />} />
                    <Route path="/college-trips" element={<TripTypePage slug="college-trips" />} />
                    <Route path="/industrial-visits" element={<TripTypePage slug="industrial-visits" />} />
                    <Route path="/corporate-trips" element={<TripTypePage slug="corporate-trips" />} />
                    <Route path="/group-tours" element={<TripTypePage slug="group-tours" />} />
                    <Route path="/destinations" element={<TripTypePage slug="destinations" />} />
                    <Route path="/contact" element={<TripTypePage slug="contact" />} />
                    <Route path="/admin" element={<AdminPage />} />
                    <Route path="/admin/set-password" element={<SetPasswordPage />} />
                    <Route path="/tour-pay/:token" element={<TourPayPage />} />
                    <Route path="/packages" element={<PackagesPage />} />
                    <Route path="/packages/:destSlug" element={<PackagesPage />} />
                    <Route path="/package/:slug" element={<PackageDetailPage />} />
                    <Route path="/compare" element={<ComparePage />} />
                    <Route path="/plan-my-trip" element={<PlanMyTripPage />} />
                    <Route path="/picnic-feedback" element={<PicnicFeedbackPage />} />
                    <Route path="/flights" element={<FlightSearchPage />} />
                    <Route path="/flights/results/:searchId" element={<FlightResultsPage />} />
                    <Route path="/flights/checkout/:searchId" element={<FlightCheckoutPage />} />
                    <Route path="/my-trips" element={<MyTripsPage />} />
                    <Route path="/partners" element={<PartnersPage />} />
                    <Route path="/partners/register" element={<PartnerRegisterPage />} />
                    <Route path="/partner/login" element={<PartnerAuthPage />} />
                    <Route path="/partner/reset" element={<PartnerAuthPage />} />
                    <Route path="/partner" element={<PartnerDashboardPage />} />
                    <Route path="/admin/packages" element={<AdminPage initialView="packages" />} />
                    <Route path="/admin/pricing" element={<AdminPage initialView="fares" />} />
                    <Route path="/admin/feedback" element={<AdminPage initialView="feedback" />} />
                    <Route path="/admin/inbox" element={<AdminPage initialView="inbox" />} />
                    <Route path="/admin/flights" element={<AdminPage initialView="flights" />} />
                    <Route path="/admin/social" element={<AdminPage initialView="social" />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
        </div>
    );
}

export default App;
